import { Notification, Text } from '@collinsonx/design-system/core';
import { ApolloError } from '@collinsonx/utils/apollo';
import { useCallback, useState } from 'react';

interface ErrorProps {
  'aria-label'?: string;
  error?: ApolloError;
  title?: string;
}

const Error = ({
  'aria-label': ariaLabel,
  error,
  title = 'An error occurred',
}: ErrorProps) => {
  const errorKey =
    error?.graphQLErrors
      ?.map((graphQLError) => graphQLError.message)
      .join(',') ?? '';
  const [dismissedErrorKey, setDismissedErrorKey] = useState<string | null>(
    null
  );

  const handleClose = useCallback(() => {
    setDismissedErrorKey(errorKey);
  }, [errorKey]);

  if (!error?.graphQLErrors?.length || dismissedErrorKey === errorKey) {
    return null;
  }

  return (
    <Notification
      aria-label={ariaLabel}
      color="red.7"
      my={8}
      onClose={handleClose}
      title={title}
      w="100%"
    >
      {error.graphQLErrors.map((err, index) => (
        <Text key={index}>{err.message}</Text>
      ))}
    </Notification>
  );
};

export default Error;
